import { useQuery } from 'react-query';
import ZentuvoInvoicingApi, { IContentProviderOption } from '../ZentuvoInvoicingApi';

export const contentProvidersQueryKey = 'zentuvo-invoicing-content-providers';

export function useContentProvidersQuery() {
    return useQuery<IContentProviderOption[]>(
        contentProvidersQueryKey,
        () => ZentuvoInvoicingApi.getContentProviders(),
        {
            staleTime: 60 * 60 * 1000
        }
    );
}
